<template>
  <div class="modal fade" id="cancel-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeCancelModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title text-danger" id="forgot_ModalLabel"><i class="fa fa-ban mr-5"></i>{{'cancel_order_item' | translate}}</h4>
        </div>
        <div class="modal-body">
          <p class="mt-10 lead"><strong>{{'cancel_item_modal_text_header' | translate}}</strong></p>
          <p class="text-danger"><i class="fa fa-warning mr-5"></i>{{'cancel_item_modal_text_body' | translate}}</p>
          <p class="margin"></p>
          <div class="row">
            <div class="col-xs-12">
              <span><strong>{{'cancellation_reason' | translate}}:</strong></span>
              <div class="mt-10 mb-10">
                <select v-model="reason" class="form-control">
                  <option class="danger" value="out_of_stock">{{'out_of_stock' | translate}}</option>
                  <option class="danger" value="article_has_defect">{{'article_has_defect' | translate}}</option>
                  <option class="danger" value="prior_sale">{{'prior_sale' | translate}}</option>
                  <option v-if="externalOrder === 1" class="danger" value="customer_cancellation">{{'cancellation_customer' | translate}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <span><strong>{{'commentary' | translate}}:</strong></span>
              <textarea class="form-control mt-10" rows="3" v-model="message"></textarea>
            </div>
          </div>
          <!--<div class="row mt-10">
            <div class="col-xs-12">
              <div class="callout callout-warning">
                <h4>{{'cancellation_description_1' | translate}}</h4>
                <p><i class="fa fa-info-circle mr-5"></i>{{'cancellation_description_2' | translate}}</p>
              </div>
            </div>
          </div>-->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-app btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate}}</button>
          <button id="bcd" onclick="this.disabled=true" @click="$emit('action', {reason: reason, message: message})" type="button" class="btn btn-success btn-app pull-right"><span class="fa fa-save"></span>{{'confirm' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  Name: 'CancelModal',
  props: ['action', 'externalOrder'],
  data () {
    return {
      reason: 'out_of_stock',
      message: ''
    }
  },
  methods: {
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/CancelModal.vue